<template>
    <div>

        <div class="component-order" v-for="order in orders">
          <figure class="component-order-image">
            <img :src="$iconFolder + 'cart.svg'"/>
          </figure>
          <div class="component-order-content">
            <h2>Commande n°<span>{{ order.invoice.reference }}</span></h2>

            <ul class="component-order-resume">
              <li class="component-order-items-item">
                <img class="icon" :src="$iconFolder + 'calendar.svg'"/>
                <div>
                  <strong>Date de facturation</strong>
                  <p>{{ order.invoice.invoiced_at }}</p>
                </div>
              </li>
              <li class="component-order-items-item">
                <img class="icon" :src="$iconFolder + 'invoice.svg'"/>
                <div>
                  <strong>Montant</strong>
                  <p>{{ order.currency }} {{ order.amount_total|formatNumber }}</p>
                </div>
              </li>
              <li class="component-order-items-item">
                <img class="icon" :src="$iconFolder + 'money.svg'"/>
                <div>
                  <strong>Statut de paiement</strong>
                  <p>{{ order.invoice.payment_status }}</p>
                </div>
              </li>
            </ul>

            <ul class="component-order-items">
              <li v-for="item in order.items" class="component-order-items-item">
                - {{ item.detail.name }}
                <span v-if="item.schedule.length"> - {{ item.schedule[0].start_at }} - {{ item.schedule[0].user ? item.schedule[0].user.name : '' }}</span>
              </li>
            </ul>

            <footer>
              <a :href="order.invoice.download_link" target="_blank" class="bt bt-create"><span>Télécharger la facture</span></a>
            </footer>

          </div>
        </div>

    </div>
</template>
<script>
    import OrderService from './OrderService.js';
    export default {
        name: 'Widget',
        props: ['person_id'],
        data () {
            return {
                orders: null
            }
        },
        mounted: function(){

            OrderService.getOrderByCustomer(this.person_id).then((response) => {
                console.log('ORDER HISTORIQUE', response.data);
                this.orders = response.data;
            }).catch((response) => {
                console.log("error", response);
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/order/OrderByPersonWidget.vue